export enum MOBILE_LOGIN {
    /**
     * @value Access giver
     */
    ACCESS_GIVER = 'MOBILE_LOGIN.ACCESS_GIVER',
    /**
     * @value Access giver can provide access receiver a QR code
     */
    ACCESS_GIVER_HELPER = 'MOBILE_LOGIN.ACCESS_GIVER_HELPER',
    /**
     * @value Access receiver
     */
    ACCESS_RECEIVER = 'MOBILE_LOGIN.ACCESS_RECEIVER',
    /**
     * @value Users in these groups are authorized to login with a QR code
     */
    ACCESS_RECEIVER_HELPER = 'MOBILE_LOGIN.ACCESS_RECEIVER_HELPER',
    /**
     * @value Add a new rule
     */
    ADD_NEW_RULE = 'MOBILE_LOGIN.ADD_NEW_RULE',
    /**
     * @value App Login Code
     */
    APP_LOGIN_CODE = 'USER_SETTINGS.APP_LOGIN_CODE',
    /**
     * @value Allow all users to log in to the mobile app using a personal login QR code from the web.
     */
    APP_LOGIN_CODE_HELPER = 'MOBILE_LOGIN.APP_LOGIN_CODE_HELPER',
    /**
     * @value Duplicated rule
     */
    DUPLICATED_RULE = 'MOBILE_LOGIN.DUPLICATED_RULE',
    /**
     * @value Enable self-registration for users
     */
    ENABLE_SELF_REGISTRATION = 'MOBILE_LOGIN.ENABLE_SELF_REGISTRATION',
    /**
     * @value Enter your custom link
     */
    LOGIN_CUSTOM_LINK = 'ADMIN.MOBILE.CUSTOM_LINK',
    /**
     * @value Enable « Don't known how to sign in? »
     */
    LOGIN_HELP_URL = 'ADMIN.MOBILE.LOGIN_HELP_URL',
    /**
     * @value Display a custom link on the login page to help users to sign in
     */
    LOGIN_HELP_URL_HELPER = 'ADMIN.MOBILE.LOGIN_HELP_URL_HELPER',
    /**
     * @value Don't know how to sign in
     */
    LOGIN_HELP_URL_PAGE_NAME = 'MOBILE_LOGIN.QR_HELP_URL_PAGE_NAME',
    /**
     * @value Manage access for
     */
    MANAGE_ACCESS_FOR = 'MOBILE_LOGIN.MANAGE_ACCESS_FOR',
    /**
     * @value Login
     */
    MOBILE_SETTINGS_LOGIN = 'ADMIN.NAV.MOBILE_SETTINGS_LOGIN',
    /**
     * @value Duplicates are not authorized. A sponsor group cannot invite the same invitee group inside multiple rules. Remove duplicates.
     */
    NO_AUTHORIZED_DUPLICATION_RULE = 'MOBILE_LOGIN.NO_AUTHORIZED_DUPLICATION_RULE',
    /**
     * @value Enable « Forgot your password? »
     */
    PASSWORD_RECOVER_URL = 'ADMIN.MOBILE.PASSWORD_RECOVER_URL',
    /**
     * @value Display a custom link on the login page to reset user's password
     */
    PASSWORD_RECOVER_URL_HELPER = 'ADMIN.MOBILE.PASSWORD_RECOVER_URL_HELPER',
    /**
     * @value Peer-to-peer login
     */
    PEER_TO_PEER_LOGIN = 'MOBILE_LOGIN.PEER_TO_PEER_LOGIN',
    /**
     * @value QR code access
     */
    QR_CODE_ACCESS = 'MOBILE_LOGIN.QR_CODE_ACCESS',
    /**
     * @value Provide access givers with QR codes. A QR code contains the ID and password of an access receiver.
     */
    QR_CODE_ACCESS_HELPER = 'MOBILE_LOGIN.QR_CODE_ACCESS_HELPER',
    /**
     * @value Select the registration form for invited users
     */
    REGISTRATION_FORM_DESCRIPTION = 'MOBILE_LOGIN.REGISTRATION_FORM_DESCRIPTION',
    /**
     * @value Registration form
     */
    REGISTRATION_FORM_TITLE = 'MOBILE_LOGIN.REGISTRATION_FORM_TITLE',
    /**
     * @value Select a registration form
     */
    SELECT_REGISTRATION_FORM = 'MOBILE_LOGIN.SELECT_REGISTRATION_FORM',
    /**
     * @value Self-registration
     */
    SELF_REGISTRATION_TITLE = 'MOBILE_LOGIN.SELF_REGISTRATION_TITLE',
    /**
     * @value Web-to-mobile login
     */
    WEB_TO_LOGIN_MOBILE = 'MOBILE_LOGIN.WEB_TO_LOGIN_MOBILE',
}
